var swal = require('sweetalert2');

module.exports = function () {
    $(document).ready(function () {

        var AjaxController = require('./services/AjaxController');

        //for update on 'Show' page
        var short_description = $("textarea[name=short_description]").val();
        var fit_out_notes = $("textarea[name=fit_out_notes]").val();
        var utilities_notes = $("textarea[name=utilities_notes]").val();

        $(document).on('change', '.js-property-update-field', function(e){

            var $this = $(this);

            var propertyId = $this.data('property'),
                field = $this.data('field'),
                value = $this.val();
            var url = '/api/properties/update-field';

            var data = {
                field: field,
                propertyId: propertyId,
                value: value
            };
            var success = function (response) {
                console.log('Success');
                }
            var error = function (response) {
                console.log('Error');
            }

            e.preventDefault();

            swal({
                title: "Are you sure you want to save changes?",
                text: "",
                type: "warning",
                showCancelButton: true
            }).
            then(function (result) {
                if (result.value) {
                    AjaxController.prototype.send(url, data, success, error);

                    if (field == 'short_description') {
                        short_description = $("textarea[name=short_description]").val();
                        $("#edited-descr").load(location.href + " #edited-descr>*", "");
                    }
                    if (field == 'fit_out_notes') {
                        fit_out_notes = $("textarea[name=fit_out_notes]").val();
                        $("#edited-fit-out").load(location.href + " #edited-fit-out>*", "");
                    }
                    if (field == 'utilities_notes') {
                        utilities_notes = $("textarea[name=utilities_notes]").val();
                        $("#edited-utilities").load(location.href + " #edited-utilities>*", "");
                    }

                } else {
                    if (field == 'short_description') {
                        $("textarea[name=short_description]").val(short_description);
                    }
                    if (field == 'fit_out_notes') {
                        $("textarea[name=fit_out_notes]").val(fit_out_notes);
                    }
                    if (field == 'utilities_notes') {
                        $("textarea[name=utilities_notes]").val(utilities_notes);
                    }
                }
            })
        });
    });
}();
